import './page-header.scss'
import { EventBus } from 'js/utility/event-bus.js'

export const component = {
    name: 'page-header',

    methods: {
        toggleMobileMenu () {
            EventBus.$emit('MobileMenu.toggle')
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/page-header/page-header.js